import EN, { LAST_UPDATED } from "@/pages/legalContent.en";
import FR from "@/pages/legalContent.fr";
import DE from "@/pages/legalContent.de";

const map = { en: EN, fr: FR, de: DE };

export const legalSectionsFor = (locale) => map[locale] || EN;
export { LAST_UPDATED };
